import { ApplicationConfig, inject, LOCALE_ID, provideAppInitializer, SecurityContext } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideMarkdown } from 'ngx-markdown';
import { provideHideAngularVersion } from '@systems/base';
import { APP_ROUTES } from './app.routes';
import { provideCore } from './core/core.module';
import { SysbizConfigLoaderService } from './core/sysbiz/config-loader.service';

function localeFactory(): string {
  if (typeof localStorage !== 'undefined') {
    const storedLocale = localStorage.getItem('locale');
    if (storedLocale) {
      return storedLocale;
    }
  }

  if (typeof navigator !== 'undefined') {
    return navigator.language;
  }

  return 'de';
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHideAngularVersion(),
    {
      provide: LOCALE_ID,
      useFactory: localeFactory
    },
    provideCore(),
    provideHttpClient(withInterceptorsFromDi()),
    provideMarkdown({ loader: HttpClient, sanitize: SecurityContext.NONE }),
    provideRouter(
      APP_ROUTES,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        //scrollOffset: [0, 50],
        scrollPositionRestoration: 'enabled'
      })
    ),
    provideAppInitializer(() => {
      const initializerFn = appInitializerFactory(inject(SysbizConfigLoaderService));
      return initializerFn();
    })
  ]
};

export function appInitializerFactory(configsLoaderService: SysbizConfigLoaderService) {
  return () => configsLoaderService.load();
}
